import React from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import teamData from "../data/teamData";
import { useParams } from "react-router-dom";
import useScrollAnimation from "../../hooks/UseScrollAnimation";
export default function TeamDetails() {
    const { t } = useTranslation();
    const { id } = useParams();
    useScrollAnimation();
    const member = teamData.find(item => item.id === id);
    if (!member) {
        return <div className="text-center text-red-500">{t("Member not found")}</div>;
    }
    return (
        <>
            <section className="landingpages">
                <div className="container h-full flex flex-col items-center justify-center text-center">
                    <div className="btmAni1256 text-[#017E89] font-bold text-[35px] capitalize">{t("Member Details")}</div>
                    <div className="btmAni2000 flex items-center gap-[5px] font-bold">
                        <Link to={"/"}>{t("Home")}</Link> -
                        <span className="text-[#017E89] capitalize">{t("Member Details")}</span>
                    </div>
                </div>
            </section>
            <section className="relative py-[40px]">
                <div className="container flex flex-col gap-[50px]">
                    <div className="btmAni25002 flex items-center gap-[7px]">
                        <img className="" src={require("../../assets/icons/lineTitle.svg").default} alt="" />
                        <div className="font-bold capitalize text-[25px] text-[#017e89]">{t("Member Details")}</div>
                    </div>
                    <div className="f-col p-5 border shadow-lg rounded-lg flex justify-between">
                        <div className="w-100 js-scroll fade-left w-[49%]">
                            <img className="w-[100%] h-[100%] object-cover rounded-[8px]" src={member.image} alt={member.name} />
                        </div>
                        <div className="w-100 w-[49%] flex flex-col gap-[25px]">
                            <div className="js-scroll fade-btm">
                                <div className="font-bold text-[#017E89] text-[20px] capitalize mt-3">{t(`${member.name}`)}</div>
                                <div className="capitalize">{t(`${member.posation}`)}</div>
                            </div>
                            <div className="js-scroll fade-btm flex items-center gap-[30px] items-baseline">
                                <div className="capitalize font-bold">{t("Speciality")}</div>
                                <div className="capitalize">{t(`${member.major}`)}</div>
                            </div>
                            <div className="js-scroll fade-btm flex items-center gap-[30px] items-baseline">
                                <div className="capitalize font-bold">{t("Degrees")}</div>
                                <div className="capitalize">{t(`${member.Degrees}`)}</div>
                            </div>
                            <div className="f-col js-scroll fade-btm flex items-center gap-[30px] items-baseline">
                                <div className="capitalize font-bold">{t("experience")}</div>
                                <div className="capitalize">{t(`${member.experience}`)}</div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </>
    );
}
